import { ChevronLeftIcon } from '../../../components/ui/icons'

interface ScreenHeaderProps {
  title: string
  subtitle?: string
  showBack?: boolean
  onBack?: () => void
  rightAction?: React.ReactNode
  sticky?: boolean
  transparent?: boolean
}

export function ScreenHeader({
  title,
  subtitle,
  showBack = false,
  onBack,
  rightAction,
  sticky = true,
  transparent = false,
}: ScreenHeaderProps) {
  return (
    <header
      className={`
        ${sticky ? 'sticky top-0 z-30' : ''}
        ${transparent ? '' : 'bg-surface-primary/95 backdrop-blur-sm border-b border-border-light'}
        px-4 pb-4 lg:pb-5
      `}
      style={{
        paddingTop: 'calc(env(safe-area-inset-top, 0px) + 1.25rem)',
      }}
    >
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            onClick={onBack}
            aria-label="Go back"
            className="
              -ml-2 p-2 rounded-xl
              text-text-secondary
              hover:text-text-primary
              hover:bg-surface-tertiary
              transition-colors
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary
            "
          >
            <ChevronLeftIcon className="size-6" />
          </button>
        )}
        
        <div className="flex-1 min-w-0">
          <h1 className="font-semibold text-text-primary truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm/5 text-text-secondary truncate">
              {subtitle}
            </p>
          )}
        </div>

        {rightAction && <div className="shrink-0">{rightAction}</div>}
      </div>
    </header>
  )
}
